import configuration from "../config.json";
import reportService from "../shared/services/reportService";
import CookieService from "../shared/services/cookiesService";
import { downloadFile } from "../shared/services/download.service";
import { setLogout } from "./authActions";

const REQUEST_DOWNLOAD_SAVED_REPORT = "REQUEST_DOWNLOAD_SAVED_REPORT";
const RESPONSE_DOWNLOAD_SAVED_REPORT = "RESPONSE_DOWNLOAD_SAVED_REPORT";
const REQUEST_DOWNLOAD_SAVED_REPORT_FAILURE = "REQUEST_DOWNLOAD_SAVED_REPORT_FAILURE";
const CLEAR_DOWNLOAD_SAVED_REPORT = "CLEAR_DOWNLOAD_SAVED_REPORT";

const requestDownloadSavedReportAction = () => {
  return {
    type: REQUEST_DOWNLOAD_SAVED_REPORT,
  };
};

const responseDownloadSavedReportAction = () => {
  return {
    type: RESPONSE_DOWNLOAD_SAVED_REPORT,
  };
};

const requestDownloadSavedReportFailureAction = () => {
  return {
    type: REQUEST_DOWNLOAD_SAVED_REPORT_FAILURE,
  };
};

const downloadSavedReport = (id, report, car, format = { title: "xlsx" }, options) => {
  return (dispatch) => {
    dispatch(requestDownloadSavedReportAction());

    reportService
      .downloadSavedReport(id)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12);
        downloadFile(result.data, report, car, format, options);
        dispatch(responseDownloadSavedReportAction());
      })
      .catch((error) => {
        dispatch(requestDownloadSavedReportFailureAction());

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearDownloadSavedReportAction = (id, format) => {
  return {
    type: CLEAR_DOWNLOAD_SAVED_REPORT,
    payload: { id, format },
  };
};

const clearDownloadSavedReport = (id, format) => {
  return (dispatch) => {
    dispatch(clearDownloadSavedReportAction(id, format));
  };
};

export {
  downloadSavedReport,
  requestDownloadSavedReportAction,
  responseDownloadSavedReportAction,
  requestDownloadSavedReportFailureAction,
  clearDownloadSavedReport,
  clearDownloadSavedReportAction,
  REQUEST_DOWNLOAD_SAVED_REPORT,
  RESPONSE_DOWNLOAD_SAVED_REPORT,
  REQUEST_DOWNLOAD_SAVED_REPORT_FAILURE,
  CLEAR_DOWNLOAD_SAVED_REPORT,
};
